export const staticAppIdNames = Object.freeze({
  PRAYER_BOOK_VI: 'sach-kinh-nguyen',
  LECTIONARY_BOOK_VI: 'sach-bai-doc-phung-vu',
})

// id document_types dùng cho trang /documents (Văn Khoa Giáo Hội) không đặt tĩnh ở đây -
// lấy động từ server qua useAppConfig('document_library_types') (xem AppConfigContext.js),
// nguồn thật ở backend config/constants.php -> document_library. Tránh 2 nguồn sự thật
// giữa frontend hardcode và backend config khi dữ liệu document_types thay đổi.
